
import Vue from 'vue';
import { Button } from '@descomplica/vue-components';
import { ENDPOINTS } from '@/settings/endpoints';

export default Vue.extend({
  components: {
    Button,
  },
  computed: {
    shouldDisplaySocialMetaverse(): boolean {
      return this.$store.getters.shouldDisplaySocialMetaverse;
    },
  },
  mounted() {
    if (!this.shouldDisplaySocialMetaverse) {
      this.$router.push({ name: 'home' });
    }
  },
  methods: {
    openLink() {
      window.open(ENDPOINTS.appGatherTown, '_blank');
    },
  },
});
